let hideTimeoutId: ReturnType<typeof setTimeout> | undefined;

function getBootScreen() {
  const bootScreen = document.querySelector('#boot-screen');

  return bootScreen instanceof HTMLElement ? bootScreen : null;
}

function clearHideTimeout() {
  if (!hideTimeoutId) return;

  clearTimeout(hideTimeoutId);
  hideTimeoutId = undefined;
}

export const enableBootScreen = () => {
  clearHideTimeout();

  document.body.style.overflowX = 'hidden';
  document.body.style.overflowY = 'visible';

  const bootScreen = getBootScreen();

  if (!bootScreen) return;

  bootScreen.style.opacity = '1';
  bootScreen.style.display = 'flex';
};

export const disableBootScreen = () => {
  clearHideTimeout();

  const bootScreen = getBootScreen();

  if (bootScreen) {
    bootScreen.style.opacity = '0';
  }

  hideTimeoutId = setTimeout(() => {
    document.body.style.overflow = 'auto';

    if (bootScreen) {
      bootScreen.style.display = 'none';
    }
  }, 700);
};

export function useBootScreen() {
  return {
    enableBootScreen,
    disableBootScreen,
  };
}
